/* tslint:disable */
/* eslint-disable */
/**
 * VoresAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateLeadResultDto
 */
export interface CreateLeadResultDto {
    /**
     * 
     * @type {string}
     * @memberof CreateLeadResultDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeadResultDto
     */
    continueUrl: string;
}

export function CreateLeadResultDtoFromJSON(json: any): CreateLeadResultDto {
    return CreateLeadResultDtoFromJSONTyped(json, false);
}

export function CreateLeadResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeadResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'continueUrl': json['continueUrl'],
    };
}

export function CreateLeadResultDtoToJSON(value?: CreateLeadResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'continueUrl': value.continueUrl,
    };
}


